import {APP_INITIALIZER, NgModule} from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatButtonModule, MatCardModule,
    MatCheckboxModule, MatDatepickerModule, MatExpansionModule, MatFormFieldModule, MatIconModule, MatInputModule,
    MatPaginatorModule, MatProgressSpinnerModule, MatSelectModule, MatSlideToggleModule, MatSortModule, MatStepperModule, MatTableModule,
    MatTabsModule, MatTreeModule } from '@angular/material';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';


import { TranslateModule } from '@ngx-translate/core';
import { AgmCoreModule } from '@agm/core';
import {MatListModule} from '@angular/material/list';
import 'hammerjs';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { fuseConfig } from './fuse-config';
import { DISPLAY_DATE_FORMAT } from './config/date_format';
import { AuthGuard } from './guards/auth.guard';
import { HttpErrorInterceptor } from './services/httperror.interceptor.service';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { environment } from '../environments/environment';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxMatDatetimePickerModule, NgxMatNativeDateModule} from 'ngx-mat-datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import {MatNativeDateModule} from '@angular/material';
import {MatNativeDatetimeModule} from '@mat-datetimepicker/core';
import { DataTablesModule } from 'angular-datatables';
import {CustomDialogComponent} from '../@fuse/components/custom-dialog/custom-dialog.component';
import {CustomDialogModule} from '../@fuse/components/custom-dialog/custom-dialog.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {ProgressBarModule} from 'angular-progress-bar';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import { AppConfigService } from './services/app-config.service';
import {LocationModule} from './main/location/location.module';

import {
    InjectableRxStompConfig,
    RxStompService,
    rxStompServiceFactory,
} from '@stomp/ng2-stompjs';

import { myRxStompConfig } from './config/my-rx-stomp.config';
import {FuseSharedModule} from '../@fuse/shared.module';
import {FuseModule} from '../@fuse/fuse.module';
import {FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule} from '../@fuse/components';
import {DueReportModule} from './main/due-report/due-report.module';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';


export function initConfig(config: AppConfigService) {
    return () => config.load();
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        DataTablesModule,
        BrowserModule,
        MatNativeDateModule,
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        NgxMatDatetimePickerModule,
        NgxMatNativeDateModule,
        NgxMatMomentModule,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDatetimeModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        BrowserAnimationsModule,
        MatListModule,
        HttpClientModule,
        NgxChartsModule,
        ProgressBarModule,
        LocationModule,
        TranslateModule.forRoot(),
        DeviceDetectorModule.forRoot(),
        NgxDaterangepickerMd.forRoot(),
        LeafletModule.forRoot(),
        RouterModule.forRoot([
            {path: 'auth', loadChildren: './main/authentication/auth.module#AuthModule'},
            {
                path: '',
                canActivate: [AuthGuard],
                children: [
                    {path: 'dashboard', loadChildren: './main/dashboard/dashboard.module#DashboardModule'},
                    {
                        path: 'tada-MarketRule',
                        loadChildren: './main/tada-MarketRule/market-rule.module#MarketRuleModule'
                    },
                    {path: 'tadaClaim', loadChildren: './main/tadaClaim/tadaClaim.module#TadaClaimModule'},
                    {
                        path: 'chemist-visit-type',
                        loadChildren: './main/chemist-visit-type/chemist-visit-type.module#ChemistVisitTypeModule'
                    },
                    {
                        path: 'site-visit-type',
                        loadChildren: './main/site-visit-type/site-visit-type.module#SiteVisitTypeModule'
                    },
                    {
                        path: 'doctor-required-visit-type',
                        loadChildren: './main/doctor-required-visit-type/doctor-required-visit-type.module#DoctorRequiredVisitTypeModule'
                    },
                    {path: 'siteVisit', loadChildren: './main/siteVisit/siteVisit.module#SiteVisitModule'},
                    {path: 'doctorVisit', loadChildren: './main/doctorVisit/doctorVisit.module#DoctorVisitModule'},
                    {path: 'chemistVisit', loadChildren: './main/chemistVisit/chemistVisit.module#ChemistVisitModule'},
                    {path: 'site', loadChildren: './main/site/site.module#SiteModule'},
                    {path: 'seen-rx', loadChildren: './main/seen-rx/seen-rx.module#SeenRxModule'},
                    {path: 'department', loadChildren: './main/department/department.module#DepartmentModule'},
                    {path: 'order-report-summary-chemist', loadChildren: './main/order-report-chemist/order-report-chemist.module#OrderReportChemistModule'},
                    {path: 'order-report-summary-product', loadChildren: './main/order-report-product/order-report-product.module#OrderReportProductModule'},

                    {path: 'survey', loadChildren: './main/survey/survey.module#SurveyModule'},
                    {path: 'exam', loadChildren: './main/exam/exam.module#ExamModule'},
                    {path: 'exam-v2', loadChildren: './main/exam-v2/exam-v2.module#ExamV2Module'},
                    {path: 'exam-list', loadChildren: './main/exam-list/exam-list.module#ExamListModule'},
                    {path: 'survey-response', loadChildren: './main/chemistSurveyRespnd/chemist-survey-respond.module#ChemistSurveyRespondModule'},
                    {path: 'siteType', loadChildren: './main/siteType/siteType.module#SiteTypeModule'},
                    {path: 'siteOwner', loadChildren: './main/site-owner-type/siteOwner.module#SiteOwnerModule'},
                    {path: 'allowance', loadChildren: './main/allowance/allowance.module#AllowanceModule'},
                    {path: 'expenseclaim', loadChildren: './main/expenseclaim/expenseclaim.module#ExpenseclaimModule'},
                    {path: 'expensetype', loadChildren: './main/expensetype/expense-type.module#ExpenseTypeModule'},
                    {path: 'inv0ice', loadChildren: './main/inv0ice/inv0ice.module#Inv0iceModule'},
                    {path: 'invoice-sync', loadChildren: './main/invoice-sync/invoice-sync.module#InvoiceSyncModule'},
                    {path: 'return', loadChildren: './main/return/return.module#ReturnModule'},
                    {path: 'route', loadChildren: './main/route/route.module#RouteModule'},
                    {path: 'milage', loadChildren: './main/milage/milage.module#MilageModule'},
                    {path: 'survey-type', loadChildren: './main/survey-type/survey-type.module#SurveyTypeModule'},

                    {path: 'delivary', loadChildren: './main/delivary/delivary.module#DelivaryModule'},
                    {path: 'sample-stock', loadChildren: './main/sample-stock/sample-stock.module#SampleStockModule'},
                    {path: 'sample-stock-allocation', loadChildren: './main/sampleAllocation/sample-allocation.module#SampleAllocationModule'},
                    {path: 'report-doctor-coverage', loadChildren: './main/report-doctor-coverage/report-doctor-coverage.module#ReportDoctorCoverageModule'},
                    {path: 'report-invoice', loadChildren: './main/report-invoice/report-invoice.module#ReportInvoiceModule'},


                    {path: 'sample-stock-allocation-report', loadChildren: './main/reportSampleAllocation/report-sample-allocation.module#ReportSampleAllocationModule'},
                    {
                        path: 'order-report-detail',
                        loadChildren: './main/order-report-detail/order-report-detail.module#OrderReportDetailModule'
                    },
                    {path: 'stock', loadChildren: './main/stock/stock.module#StockModule'},
                    {path: 'transport', loadChildren: './main/transport/transport.module#TransportModule'},
                    {path: 'organization', loadChildren: './main/organization/organization.module#OrganizationModule'},
                    {path: 'bill-pending-organization', loadChildren: './main/bill-pending-organization/bill-pending-organization.module#BillPendingOrganizationModule'},
                    {path: 'training', loadChildren: './main/training/training.module#TrainingModule'},
                    {
                        path: 'doctor-approval-rules',
                        loadChildren: './main/doctor-approval-rules/doctorApproveRules.module#DoctorApproveRulesModule'
                    },
                    {
                        path: 'userleaveApproveRules',
                        loadChildren: './main/userleaveApproveRules/userleaveApproveRules.module#UserleaveApproveRulesModule'
                    },
                    {
                        path: 'tourplanApproveRules',
                        loadChildren: './main/tourApproveRules/tourApproveRules.module#TourApproveRulesModule'
                    },
                    {
                        path: 'visitApproveRules',
                        loadChildren: './main/visitApproveRules/visitApproveRules.module#VisitApproveRulesModule'
                    },
                    {
                        path: 'surveyChemistApproveRules',
                        loadChildren: './main/surveyChemistApproveRules/suveyChemistApproveRules.module#SuveyChemistApproveRulesModule'
                    },
                    {
                        path: 'surveyDoctorApproveRules',
                        loadChildren: './main/surveyDoctorApproveRules/suveyDoctorApproveRules.module#SuveyDoctorApproveRulesModule'
                    },
                    {
                        path: 'surveySiteApproveRules',
                        loadChildren: './main/surveySiteApproveRules/suveySiteApproveRules.module#SuveySiteApproveRulesModule'
                    },
                    {
                        path: 'customerApproveRules',
                        loadChildren: './main/customerApproveRules/customerApproveRules.module#CustomerApproveRulesModule'
                    },
                    {
                        path: 'employeeApproveRules',
                        loadChildren: './main/employeeApproveRules/employeeApproveRules.module#EmployeeApproveRulesModule'
                    },
                    {
                        path: 'expenseclaimApproveRules',
                        loadChildren: './main/expenseclaimApproveRules/expenseclaimApproveRules.module#ExpenseclaimApproveRulesModule'
                    },
                    {
                        path: 'paymentApproveRule',
                        loadChildren: './main/paymentApproveRule/paymentApproveRule.module#PaymentApproveRuleModule'
                    },
                    {
                        path: 'orderApproveRules',
                        loadChildren: './main/orderApproveRules/orderApproveRules.module#OrderApproveRulesModule'
                    },
                    {path: 'payment', loadChildren: './main/payment/payment.module#PaymentModule'},
                    {path: 'bank-account', loadChildren: './main/bank-account/bank-account.module#BankAccountModule'},
                    {
                        path: 'payment-method',
                        loadChildren: './main/payment-method/payment-method.module#PaymentMethodModule'
                    },
                    {path: 'market-level', loadChildren: './main/market-level/market-level.module#MarketLevelModule'},
                    {path: 'sales-center', loadChildren: './main/sales-center/sales-center.module#SalesCenterModule'},
                    {path: 'market', loadChildren: './main/market/market.module#MarketModule'},
                    {path: 'user-role', loadChildren: './main/user-role/user-role.module#UserRoleModule'},
                    {path: 'user', loadChildren: './main/user/user.module#UserModule'},
                    {path: 'chemist', loadChildren: './main/chemist/chemist.module#ChemistModule'},
                    {path: 'chemist-type', loadChildren: './main/chemist-type/chemist-type.module#ChemistTypeModule'},
                    {path: 'doctor', loadChildren: './main/doctor/doctor.module#DoctorModule'},
                    {path: 'degree', loadChildren: './main/degree/degree.module#DegreeModule'},
                    {path: 'rxFrom', loadChildren: './main/rx/rx.module#RxModule'},
                    {path: 'rx-survey-type', loadChildren: './main/rx-survey-type/rx-survey-type.module#RxSurveyTypeModule'},
                    {path: 'rx-survey', loadChildren: './main/rx-survey/rx-survey.module#RxSurveyModule'},
                    {path: 'survey-doctor', loadChildren: './main/survey-doctor/survey-doctor.module#SurveyDoctorModule'},

                    {
                        path: 'doctor-designation',
                        loadChildren: './main/doctor-designation/doctor-designation.module#DoctorDesignationModule'
                    },
                    {
                        path: 'doctor-category',
                        loadChildren: './main/doctor-category/doctor-category.module#DoctorCategoryModule'
                    },
                    {
                        path: 'doctor-image-type',
                        loadChildren: './main/doctor-image-type/doctor-image-type.module#DoctorImageTypeModule'
                    },
                    {path: 'speciality', loadChildren: './main/speciality/speciality.module#SpecialityModule'},
                    {path: 'chamber-type', loadChildren: './main/chamber-type/chamber-type.module#ChamberTypeModule'},
                    {path: 'patient-type', loadChildren: './main/patient-type/patient-type.module#PatientTypeModule'},
                    {path: 'contact-type', loadChildren: './main/contact-type/contact-type.module#ContactTypeModule'},
                    {path: 'group', loadChildren: './main/segment/segment.module#SegmentModule'},
                    {path: 'sub-group', loadChildren: './main/sub-segment/sub-segment.module#SubSegmentModule'},
                    {path: 'special-day', loadChildren: './main/special-day/special-day.module#SpecialDayModule'},
                    {path: 'doctor-visit', loadChildren: './main/doctor-visit/doctor-visit.module#DoctorVisitModule'},

                    {
                        path: 'doctor-visit-type',
                        loadChildren: './main/doctor-visit-type/doctor-visit-type.module#DoctorVisitTypeModule'
                    },
                    {path: 'product-line', loadChildren: './main/product-line/product-line.module#ProductLineModule'},
                    {
                        path: 'product-brand',
                        loadChildren: './main/product-brand/product-brand.module#ProductBrandModule'
                    },
                    {path: 'product-type', loadChildren: './main/product-type/product-type.module#ProductTypeModule'},
                    {
                        path: 'therapeutic-group',
                        loadChildren: './main/therapeutic-group/therapeutic-group.module#TherapeuticGroupModule'
                    },
                    {
                        path: 'generic-group',
                        loadChildren: './main/generic-group/generic-group.module#GenericGroupModule'
                    },
                    {path: 'product', loadChildren: './main/product/product.module#ProductModule'},
                    {
                        path: 'product-price',
                        loadChildren: './main/product-price/product-price.module#ProductPriceModule'
                    },
                    {path: 'attendance', loadChildren: './main/attendance/attendance.module#AttendanceModule'},
                    {path: 'location', loadChildren: './main/location/location.module#LocationModule'},
                    {path: 'tour-plan', loadChildren: './main/tour-plan/tour-plan.module#TourPlanModule'},
                    {path: 'holiday', loadChildren: './main/holiday/holiday.module#HolidayModule'},
                    {path: 'leave-type', loadChildren: './main/leave-type/leave-type.module#LeaveTypeModule'},
                    {
                        path: 'leave-allocation',
                        loadChildren: './main/leave-allocation/leave-allocation.module#LeaveAllocationModule'
                    },
                    {
                        path: 'leave-account',
                        loadChildren: './main/leave-account/leave-account.module#LeaveAccountModule'
                    },
                    {path: 'leave', loadChildren: './main/user-leave/user-leave.module#UserLeaveModule'},
                    {path: 'tour-type', loadChildren: './main/tour-type/tour-type.module#TourTypeModule'},
                    {path: 'tour-purpose', loadChildren: './main/tour-purpose/tour-purpose.module#TourPurposeModule'},
                    {path: 'daily-shift', loadChildren: './main/daily-shift/daily-shift.module#DailyShiftModule'},
                    {
                        path: 'institute-type',
                        loadChildren: './main/institute-type/institute-type.module#InstituteTypeModule'
                    },
                    {path: 'institute', loadChildren: './main/institute/institute.module#InstituteModule'},
                    {
                        path: 'report-attendance',
                        loadChildren: './main/report-attendance/report-attendance.module#ReportAttendanceModule'
                    },
                    {
                        path: 'prescription-type',
                        loadChildren: './main/prescription-type/prescription-type.module#PrescriptionTypeModule'
                    },
                    {path: 'reject-reason', loadChildren: './main/reject-reason/reject-reason.module#RejectReasonModule'},
                    {path: 'prescription', loadChildren: './main/prescription/prescription.module#PrescriptionModule'},
                    {path: 'competitor', loadChildren: './main/competitor/competitor.module#CompetitorModule'},
                    {path: 'competitor-brand', loadChildren: './main/competitor-brand/competitor-brand.module#CompetitorBrandModule'},

                    {
                        path: 'report-expense-claim',
                        loadChildren: './main/report-monthly-expense-claim/monthly-expense-claim-report.module#MonthlyExpenseClaimReportModule'
                    },
                    {path: 'report-dcr', loadChildren: './main/report-dcr/report-dcr.module#ReportDcrModule'},
                    {path: 'report-user-count', loadChildren: './main/activeDayCountReport/activeDayCount.module#ActiveDayCountModule'},
                    {
                        path: 'report-prescription',
                        loadChildren: './main/report-prescription/report-prescription.module#ReportPrescriptionModule'
                    },
                    {
                        path: 'report-visitplan',
                        loadChildren: './main/report-visitplan/report-visitplan.module#ReportVisitplanModule'
                    },
                    {path: 'order', loadChildren: './main/order/order.module#OrderModule'},
                    {path: 'notice-board', loadChildren: './main/notice-board/notice-board.module#NoticeBoardModule'},
                    {path: 'target', loadChildren: './main/target/target.module#TargetModule'},
                    {path: 'campaign', loadChildren: './main/campaign/campaign.module#CampaignModule'},
                    {
                        path: 'doctor-visit-plan',
                        loadChildren: './main/doctor-visit-plan/doctor-visit-plan.module#DoctorVisitPlanModule'
                    },
                    {
                        path: 'central-stock',
                        loadChildren: './main/central-stock/central-stock-module#CentralStockModule'
                    },
                    { path: 'admin-settings', loadChildren: './main/admin-settings/admin-settings.module#AdminSettingsModule' },
                    { path: 'doctor-order', loadChildren: './main/doctor-order/doctor-order.module#DoctorOrderModule' },
                    { path: 'doctor-order-report', loadChildren: './main/doctor-order-report/doctor-order-report.module#DoctorOrderReportModule' },
                    { path: 'sub-speciality', loadChildren: './main/sub-speciality/sub-speciality.module#SubSpecialityModule' },
                    { path: 'order-report-user', loadChildren: './main/order-report-user/order-report-user.module#OrderReportUserModule' },
                    { path: 'ta-da-claim-approval', loadChildren: './main/ta-da-approval-rules/ta-da-approval-rules.module#TaDaApprovalRulesModule' },
                    { path: 'report-doctor', loadChildren: './main/report-doctor/report-doctor.module#ReportDoctorModule' },
                    { path: 'due-report', loadChildren: './main/due-report/due-report.module#DueReportModule' },
                    { path: 'user-distance-wise-tada-rule', loadChildren: './main/user-distance-wise-tada-rule/user-distance-wise-tada-rule.module#UserDistanceWiseTadaRuleModule' },
                    { path: 'report-tour-plan', loadChildren: './main/report-tour-plan/report-tour-plan.module#ReportTourPlanModule' },
                    { path: 'doctor-record', loadChildren: './main/doctor-record/doctor-record.module#DoctorRecordModule' },
                    {path: 'doctor-service', loadChildren: './main/doctor-service/doctor-service.module#DoctorServiceModule'},
                    {path: 'doctor-proposal', loadChildren: './main/doctor-proposal/doctor-proposal.module#DoctorProposalModule'},
                    {path: 'patient', loadChildren: './main/patient/patient.module#PatientModule'},
                    {path: 'patient-rx-order', loadChildren: './main/patient-rx-order/patient-rx-order.module#PatientRxOrderModule'},
                    {path: 'weekend', loadChildren: './main/weekend/weekend.module#WeekendModule'},
                    {path: 'user-allowance', loadChildren: './main/user-allowance/user-allowance.module#UserAllowanceModule'},
                    {path: 'user-role-wise-allowance-rule', loadChildren: './main/user-role-wise-allowance-rule/user-role-wise-allowance-rule.module#UserRoleWiseAllowanceRuleModule'},
                    {path: '**', redirectTo: 'dashboard'},
                    {path: '***', redirectTo: 'admin-dashboard'}
                ]
            }
        ]),

        // Material moment date module
        MatMomentDateModule,
        CustomDialogModule,
        // Material
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatStepperModule,
        MatCheckboxModule,
        MatTreeModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatDatepickerModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [AppConfigService],
            multi: true
        },
        {
            provide: InjectableRxStompConfig,
            useValue: myRxStompConfig,
        },
        {
            provide: RxStompService,
            useFactory: rxStompServiceFactory,
            deps: [InjectableRxStompConfig],
        },
        {
            provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true
        },
        AuthGuard,
        {
            provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]
        },
        {
            provide: MAT_DATE_FORMATS, useValue: DISPLAY_DATE_FORMAT
        }
    ],
    entryComponents: [
        CustomDialogComponent,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
